<template>
  <v-dialog
    ref="dialog"
    v-model="menu2"
    class="poppins"
    width="700"
    transition="dialog-bottom-transition"
    content-class="mx-0 d-flex justify-content-center align-items-center elevation-0"
  >
    <template v-slot:activator="{ on, attrs }">
      <!--      <v-text-field-->
      <!--        outlined-->
      <!--        label="Date range"-->
      <!--        append-icon="mdi-calendar"-->
      <!--        class="mx-1"-->
      <!--        dense-->
      <!--        v-bind="attrs"-->
      <!--        v-on="on"-->
      <!--        :value="filterData['date']"-->
      <!--      />-->
      <v-text-field
        :value="inputValue"
        v-bind="attrs"
        v-on="on"
        dense
        outlined
        placeholder="Select a date"
        hide-details
        class="min-w-275px"
        style="border-radius: 10px !important; min-height: 40px !important"
      >
        <template v-slot:prepend-inner>
          <span class="svg-icon svg-icon-2 mb-0 mr-2">
            <v-icon size="22">mdi-calendar</v-icon>
          </span>
        </template>
      </v-text-field>
    </template>
    <template v-slot:default v-if="menu2 === true">
      <date-range-picker
        class="bg-white w-100 w-md-auto"
        ref="picker"
        opens="inline"
        :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
        :close-on-esc="false"
        :showDropdowns="true"
        :ranges="ranges"
        min-date="01-01-2018"
        :max-date="new Date().toLocaleDateString()"
        v-model="dateRange"
        control-container-class="d-none"
      >
        <!--            @select="selectDate"-->
        <!--        <template v-slot:input="picker">-->
        <!--          <div class="h-100 d-flex align-center">-->
        <!--            &lt;!&ndash;        <span class="svg-icon svg-icon-2 mr-2">&ndash;&gt;-->
        <!--            &lt;!&ndash;          <v-icon size="22">mdi-calendar</v-icon>&ndash;&gt;-->
        <!--            &lt;!&ndash;        </span>&ndash;&gt;-->

        <!--            &lt;!&ndash; <input-->
        <!--          type="text"-->
        <!--          placeholder="Select a date"-->
        <!--          class="border rounded"-->
        <!--          :value="picker.rangeText === ' - ' ? '' : picker.rangeText"-->
        <!--        /> &ndash;&gt;-->

        <!--            <v-text-field-->
        <!--              :value="picker.rangeText === ' - ' ? '' : picker.rangeText"-->
        <!--              dense-->
        <!--              outlined-->
        <!--              placeholder="Select a date"-->
        <!--              hide-details-->
        <!--              class="min-w-275px"-->
        <!--              style="-->
        <!--                border-radius: 10px !important;-->
        <!--                min-height: 40px !important;-->
        <!--              "-->
        <!--            >-->
        <!--              <template v-slot:prepend-inner>-->
        <!--                <span class="svg-icon svg-icon-2 mb-0 mr-2">-->
        <!--                  <v-icon size="22">mdi-calendar</v-icon>-->
        <!--                </span>-->
        <!--              </template>-->
        <!--            </v-text-field>-->
        <!--          </div>-->
        <!--        </template>-->

        <template v-slot:footer="picker">
          <div
            class="drp-buttons py-4 px-6 poppins d-flex justify-content-space-between"
          >
            <div>
              <!--          <v-select-->
              <!--            v-model="selectedDateRangeType"-->
              <!--            :items="dateRangeTypes"-->
              <!--            item-text="text"-->
              <!--            item-value="index"-->
              <!--            dense-->
              <!--            outlined-->
              <!--            placeholder="Filter by"-->
              <!--            hide-details-->
              <!--            class="sku-report__input"-->
              <!--          />-->
              <v-select
                outlined
                label="Filter by"
                class="poppins"
                style="width: 85%"
                v-model="filterData['select']"
                :items="filter.values"
                item-text="text"
                item-value="index"
                dense
                clearable
                hide-details
              />
            </div>
            <div class="d-flex align-center justify-content-end flex-grow-1">
              <button
                type="button"
                class="btn btn-light py-2 px-4 mr-3"
                @click="
                  () => {
                    picker.clickCancel;
                    handleDialog();
                  }
                "
              >
                Cancel</button
              ><button
                @click="
                  () => {
                    picker.clickApply;
                    handleDialog(picker.rangeText);
                  }
                "
                type="button"
                class="btn btn--print-upload py-2 px-4"
              >
                Apply
              </button>
            </div>
          </div>
        </template>
      </date-range-picker>
    </template>
  </v-dialog>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
  name: "DateTimePickerWithBorder",
  components: { DateRangePicker },
  props: {
    position: { type: String, default: "center" },
    filter: {
      required: true,
      type: Object,
    },
  },
  data() {
    let startDate = new Date();

    const startDatesMonth = startDate.getMonth();
    startDate.setMonth(startDatesMonth - 1);
    startDate.setDate(1);
    startDate.setHours(0, 0);

    let endDate = new Date();
    endDate.setHours(23, 59);

    return {
      dateRange: {
        startDate,
        endDate,
      },
      filterData: {
        // dateRange: { startDate: null, endDate: null },
        select: undefined,
      },
      menu2: false,
      inputValue: "",
    };
  },
  // mounted() {
  //   this.updateDateValue();
  //   this.getThemeType();
  // },
  mounted() {
    if (this.filter?.values?.length) {
      this.filterData["select"] = this.filter.values[0].index;
    }
  },
  methods: {
    handleDialog(rangeText) {
      if (rangeText) {
        this.inputValue = rangeText;
        // const { date_range, select } = this.dataOfFilters();
        // console.log(date_range, select);
        // this.$emit("on-submit", date_range, select);

        const dateArray = rangeText.split(" - ");
        const splitDates = dateArray.map((date) =>
          date.substring(0, 16).replace(/\//g, "-")
        );
        this.$emit("on-submit", splitDates, this.filterData.select);
      } else this.inputValue = "";
      setTimeout(() => {
        this.$refs.picker.togglePicker(false);
        this.menu2 = false;
      }, 100);
    },
    dataOfFilters() {
      let startDate, endDate;
      const pattern = /^\d{1,2}\/\d{1,2}\/\d{2,4}$/;

      if (pattern.test(this.dateRange.startDate)) {
        startDate = this.slashSeperatedToISO(this.dateRange.startDate);
        endDate = this.slashSeperatedToISO(this.dateRange.endDate);
      } else {
        startDate = this.extendedToISO(this.dateRange.startDate);
        endDate = this.extendedToISO(this.dateRange.endDate);
      }
      const filterData = {
        date_range: [startDate, endDate],
        select: this.filterData.select,
      };
      return filterData;
    },
    slashSeperatedToISO(date) {
      const [month, day, year] = date.split("/");
      const js_date = new Date(year, month - 1, day);
      return this.dateFormatter(js_date);
    },
    extendedToISO(val) {
      const date = new Date(val);
      return this.dateFormatter(date);
    },
    today() {
      const d = new Date();
      return this.dateFormatter(d);
    },
    updateDateValue() {
      let startDate, endDate;
      const pattern = /^\d{1,2}\/\d{1,2}\/\d{2,4}$/;

      if (pattern.test(this.dateRange.startDate)) {
        startDate = this.slashSeperatedToISO(this.dateRange.startDate);
        endDate = this.slashSeperatedToISO(this.dateRange.endDate);
      } else {
        startDate = this.extendedToISO(this.dateRange.startDate);
        endDate = this.extendedToISO(this.dateRange.endDate);
      }

      this.$emit("on-submit", [startDate, endDate], this.filterData.select);
    },
    dateFormatter(date, charForJoin = "-") {
      return [
        date.getFullYear(),
        date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : `0${date.getMonth() + 1}`,
        date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`,
      ].join(charForJoin);
    },
  },
  computed: {
    ranges: function () {
      // if (this.theme === "Basic") return false;

      let today = new Date();
      today.setHours(0, 0, 0, 0);

      let yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);
      yesterday.setHours(0, 0, 0, 0);

      return {
        Today: [today, today],
        Yesterday: [yesterday, yesterday],
        "Last 7 Days": [
          new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7),
          new Date(today.getFullYear(), today.getMonth(), today.getDate()),
        ],
        "Last 30 Days": [
          new Date(today.getFullYear(), today.getMonth(), today.getDate() - 30),
          new Date(today.getFullYear(), today.getMonth(), today.getDate()),
        ],
        "This month": [
          new Date(today.getFullYear(), today.getMonth(), 1),
          new Date(today.getFullYear(), today.getMonth(), today.getDate()),
        ],
        "Last month": [
          new Date(today.getFullYear(), today.getMonth() - 1, 1),
          new Date(today.getFullYear(), today.getMonth(), 0),
        ],
        "This year": [
          new Date(today.getFullYear(), 0, 1),
          new Date(today.getFullYear(), today.getMonth(), today.getDate()),
        ],
        "Last year": [
          new Date(today.getFullYear() - 1, 0, 1),
          new Date(today.getFullYear() - 1, 12, 31),
        ],
      };
    },
  },
  // watch: {
  //   theme(val) {
  //     const color = val === "Classic" ? "#fbfaf8" : "white";
  //     document.documentElement.style.setProperty(
  //       "--dynamic-datepicker-bg",
  //       color
  //     );
  //   },
  // },
};
</script>

<style lang="scss">
.table-condensed {
  // .off {
  //   display: none;
  // }
  .off.in-range {
    background-color: #ebf4f8 !important;
  }
  .end-date {
    background-color: rgba(183, 4, 126, 0.8) !important;
  }
}
.weekend.active.in-range.end-date {
  background-color: rgba(183, 4, 126, 0.8) !important;
}
.date-range-selector {
  margin-top: 10px !important;
  .v-input__control {
    .v-input__slot {
      font-size: 12px;
      font-weight: 600;
    }
  }
}
.vue-daterange-picker {
  .form-control {
    border: none;
  }
}
.show-calendar {
  background-color: var(--dynamic-datepicker-bg, "white");
}

.sku-report__input ::v-deep .v-input__slot {
  border-radius: 10px !important;
  min-height: 40px !important;
}

.daterangepicker {
  margin-top: 0px !important;
}
</style>
